module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Illustration",
      "id": "chap1",
      "src": "images/chap1.jpg"
    }
  })])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("DELIGHT YOURSELF IN GOD")])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Stop, pray and listen.")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Open yourself to the eternal One")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("present all around.")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Take time to notice the markers")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("of God’s abiding presence")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("and rejoice in God’s enduring acts.")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Pause to acknowledge")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("how far we have come")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("on this journey toward life.")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Hold on to the signs")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("that nudge us onward along the path")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("that leads into the loving heart of the One")])]), _c('p', {
    staticClass: "txt_courant_centre last"
  }, [_c('i', [_vm._v("who is making all things new.")])])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_c('i', [_vm._v("What about me gives God joy?")]), _vm._v(" When I first asked myself this question, my mind went blank. I sat in silence for five minutes trying to think of one thing that I thought God liked about me. I knew God loved me, after all love is the essence of who God is. To love is God’s nature, almost, one might think, God’s duty. That God might actually enjoy who I am and love me because of that enjoyment rather than out of a sense of obligation was a new concept.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("So I pulled out a blank sheet of paper and some gel pens and began to create. I wrote the words “What about me gives God joy?” in large "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("letters with a colored pen. I paused, recited the words, picked up a different colored pen and wrote over my first set of letters. One color followed another until my words were a rainbow of delightful images. Each time I wrote the words, I recited them slowly to myself.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("Finally, I sat and prayerfully looked at my lettering. "), _c('i', [_vm._v("What about me gives you joy, Lord? ")]), _vm._v("I asked again. "), _c('i', [_vm._v("I am fearfully and wonderfully made, and God delights in me")]), _vm._v(", I thought. I pulled out my Bible and read Psalm 139.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("Suddenly God’s presence embraced me in a tangible way I had never experienced before. I was reminded of Eric Liddell, Scottish Olympic gold medal winner in the 1920s whose life was highlighted in the film "), _c('i', [_vm._v("Chariots of Fire")]), _vm._v(". At one point he tells his sister, “[God] made me fast. And when I run I sense His pleasure.”")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_c('i', [_vm._v("What do I enjoy doing that makes me sense God’s pleasure? ")]), _vm._v("I pondered as the joy of God bubbled up inside me. It was as though God had been waiting for me to ask this all my life.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("The words started to flow:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("I sense God’s pleasure when I let go of my busyness, sit quietly and allow God’s presence to permeate my being and lodge in my soul.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_autre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("I sense God’s pleasure when my creative juices flow and I express my love for God by painting rocks, planting contemplative gardens, and writing prayers.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_autre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("I sense God’s pleasure when my husband and I sit together in the evening and take time just to enjoy each other.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_autre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("I sense God’s pleasure when I pull weeds, plant, and prune in the garden, even when I just admire its beauty.")])]), _c('p', {
    staticClass: "txt_courant_justif retrait_autre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("I sense God’s pleasure when I help others along the pathway toward a more intimate relationship with God and enable them to become more of whom God created them to be.")])]), _c('p', {
    staticClass: "txt_courant_justif last retrait_autre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("I sense God’s pleasure when I speak out against injustice and oppression and commit myself to wholeness, peace, and shalom.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("God doesn’t just love me, God delights in me and who I am created to be, I realize. It was a revolutionary and transforming idea.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("I now use this exercise regularly when I journal on Sundays. I might focus on the day or past week. Sometimes I reflect back over several months or a whole year. It is wonderful to be reminded of what God delights in about me and how my daily choices can increase that delight. It has brought a joy and closeness to my relationship that I never anticipated.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("The prayer at the beginning of this chapter came out of this process. It encourages me to slow down and notice while focusing my attention on my growing understanding of what it means to not only delight in God but to recognize God’s delight in me.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_c('i', [_vm._v("What do you enjoy doing that makes you sense God’s pleasure?")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-001"
    }
  }, [_vm._v("According to Andrew Newberg and Mark Robert Waldman, “the human brain is uniquely constructed to perceive and generate spiritual realities.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-010",
      "id": "ap_ntf-010-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" I suspect this innate spirituality is part of our DNA, deeply rooted in our identity as children of God. Perhaps it is also because this is where our joy in life is rooted. We are designed to draw pleasure from our spiritual practices and interactions with God.")]), _c('div', {
    staticClass: "encsansfilet",
    attrs: {
      "id": "enc-003"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('figure', {
    staticClass: "fighaut",
    attrs: {
      "id": "carre"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/carre.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("What do you enjoy doing that makes you sense God’s pleasure?")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When we pray, our brains are changed. Meditation makes us more compassionate and caring toward others. Worshiping together activates pheromones in our bodies that strengthen community. Faith tempers anxiety and fear. We are created to live in love, enjoy God, and bring joy to God not alone but as a united global family.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("No wonder even nonreligious people crave spirituality. No wonder our exploration of spiritual practices has the potential to light up our brains and delight our hearts as they open doorways into God’s eternal world of love and peace.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Unfortunately, we often allow what someone else enjoys, rather than what delights us, to shape our practices, and that doesn’t always "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("bring joy to us or God. Consequently, many lose their way and find no joy in the journey.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Spiritual but not religious” is used to describe a growing number of people, especially young people for whom church and traditional spiritual practices and worship are no longer satisfying. Many guiltily confess they experience more joy and feel closer to God in nature, yoga, social entrepreneurship, or community service than they do in their Sunday worship service. Some quietly leave church because they get little help in connecting these joy-filled moments to their faith. Others embrace contemplative practices such as lectio divina, labyrinths, and meditation, but receive little encouragement to venture into new pathways. Church activities like prayer stations can tap into this hunger and provide inspirational and experiential practices to bring to our traditional services. Other personal practices, from poetry, knitting, or whittling while praying and meditating while gardening, show an emerging world of creativity for individuals and communities of faith that bring joy to their lives and to the heart of God.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We are all unique expressions of our loving God. How we relate to God says something of who we are and of who God is. Yet we are rarely encouraged to explore or nurture that uniqueness and how it can draw us into God’s presence.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What do you enjoy about God? and What are you choosing that gives God joy? should be at the forefront of our spiritual exploration. When I suggested this to a friend who attends Bethel Church in Redding, California, she told me that this church has a similar understanding and encourages people to ask God, "), _c('i', [_vm._v("What do you enjoy about me, Lord?")]), _vm._v(" or even "), _c('i', [_vm._v("What do you think about me, Lord? ")]), _vm._v("They then prayerfully write down whatever comes to mind.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("REJOICING THE HEART OF GOD")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("My greatest joy as a medical doctor was the thrill of delivering babies. I gazed in awe as the baby’s head emerged and held my breath as I "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("waited for its first cry. I delighted in holding the small, squirming body in my hands and loved watching the tears of joy stream down the mother’s face as I passed the newborn infant to her. The grin spreading across the father’s face made me want to dance and shout with the thrill of it all. I imagine God looked over my shoulder with this same delight.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I experienced that same joy when I was reborn as a child of God. I still vividly remember sitting on a rock on a warm summer’s afternoon looking out over the Lane Cove River in Sydney. As I bowed my head in prayer, the fragrance of gum leaves filled my senses, and my heart sang to the joyful shouts of parrots and the deafening sound of cicadas. My world exploded in joy.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In the weeks that followed I really did feel as though I had been born again. Everything was new and fresh. I couldn’t stop smiling. Awe and wonder, a glimpse of the magical kingdom of God, surrounded me. No wonder Jesus told Nicodemus, “No one can see the kingdom of God unless they are born again” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=John+3%3A3&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("John 3:3")]), _vm._v(" NIV). To enter the kingdom we must be reborn into the delights of childhood.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The disciples get the same response when they ask what it will take for them to enter the kingdom of heaven: “Truly I tell you, unless you change and become like little children, you will never enter the kingdom of heaven. Therefore, whoever takes the lowly position of this child is the greatest in the kingdom of heaven” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Matthew+18%3A3-4&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Matthew 18:3-4")]), _vm._v(" NIV).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("On another occasion Jesus becomes elated and prays with joy, “Thank you, Father, Lord of heaven and earth. Thank you for hiding Your mysteries from the wise and intellectual, instead revealing them to little children” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Luke+10%3A21&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Luke 10:21")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is easy for us to dismiss this as a metaphor, even if our conversion experiences brought a sense of childlike exuberance. However the great Swiss theologian Hans Urs von Balthasar suggests that we need to take it literally. He believes that our alienation from God has buried in oblivion much of who God created us to be. He sees conversion as a rebirth into a truly childlike mentality in order to participate in God’s kingdom. “This "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("demands of Jesus’ listener a reawakening to his true origin, to which he has turned his back, a spiritual turnabout (unless you convert and become like children) that will enable him to become aware of himself.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-011",
      "id": "ap_ntf-011-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Balthasar sees childlikeness particularly in terms of dependency. Only in once more recognizing our total reliance on God can we enter the kingdom.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("However, I think it goes much further than that. God’s kingdom is a new world with a totally new culture, new language, customs, values, and purpose. To delight in God, enjoy God’s eternal world, and enter the fullness of life it offers, we must be reborn and learn to delight in this very different world where the language, culture, and customs are summed up in the words, “You shall love—‘love the Eternal One your God with everything you have: all your heart, all your soul, all your strength, and all your mind’—and ‘love your neighbor as yourself’” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Luke+10%3A27&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Luke 10:27")]), _vm._v(").")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Love permeates everything God is and does. It entwines our souls. It should be what fires our imaginations and schedules our time. It should determine what breaks our hearts and what we celebrate with joy.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What unveils this love in us? Not our intelligence, theological knowledge, or spiritual maturity but our childlikeness—curiosity and questioning, and willingness to make mistakes, live with ignorance, delight in stories, love nature, have fun playing, and be blind to color, creed, age, and social strata in those we associate with. This rejoices the heart of God and makes us fit for the kingdom. So why don’t our spiritual practices always reflect that?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I have spent many years traveling in countries not my own, feeling uncomfortable in the cultures, unable to understand the language. Even now, though I have lived in America for twenty-five years, I struggle to understand some aspects of the culture. It is hard. It’s not just that my accent is different or that I interpret words differently. At times I feel as though I am on a different wavelength. My humor falls flat. The fun things of my childhood have no meaning. I have had to be born again in order to fit in.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("No wonder we need to be reborn to enter the kingdom of God. To learn this language of love, trust in this God of love, and live into God’s culture of love, we must enter as infants and move slowly toward childlike maturity. Children learn new languages and cultures far better than we adults do.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It was reading "), _c('i', [_vm._v("The Book of Joy")]), _vm._v(" by the Dalai Lama and Desmond Tutu that really connected me to God’s joy and the rebirthing pathway I should follow to embrace it. These two amazing men, who survived more than fifty years of what could have been soul-crushing violence and exile, are some of the most joyful, loving people on the planet. “Joy is a way of approaching the world,” says the Archbishop Tutu."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-012",
      "id": "ap_ntf-012-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Our greatest joy, he contends, is when we seek to do good for others, share generously, and show compassion. The more we turn toward others, the more joy we experience; and the more joy we experience, the more we can bring joy to others. The goal is not just to create joy for ourselves but as the archbishop poetically phrased it, “to be a reservoir of joy, an oasis of peace, a pool of serenity that can ripple out to all those around you.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-013",
      "id": "ap_ntf-013-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My own spiritual journey toward a God who delights in life, love, and beauty also emerged in a place of deep pain about thirty-five years ago. Two months working on the Thai-Cambodian border with Khmer refugees who had fled the Pol Pot regime in Cambodia turned my faith upside down. Starving kids died in my arms. Their mothers told horrifying stories of rape, violence, and atrocity. "), _c('i', [_vm._v("Does God care? If so where is the God of love I believe in, and what does this God expect of me in the midst of these horrors?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Following this painful experience, I began exploring the biblical concept of shalom and God’s desire for the restoration of the wholeness, flourishing, and prosperity of the original creation. As I melded this into my understanding of Sabbath, my desire to make life choices that brought joy to God really began to come into focus and reshape my spiritual practices.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("In his book "), _c('i', [_vm._v("The Sabbath")]), _vm._v(", Jewish philosopher Abraham Heschel tells of how ancient rabbis puzzled over Genesis 2:2, “On the seventh day God finished his work,” which implied to them that there was an act of creation on this day too. They concluded that what was created on the seventh day was “harmony, peace and repose—"), _c('i', [_vm._v("menuha")]), _vm._v("—the world of shalom, wholeness and abundance, the world as God intended it to be.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-014",
      "id": "ap_ntf-014-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Then God looks at this world and proclaims, “It is very good.” Theologian Norman Wirzba suggests that what is expressed here is God’s excitement and enthusiasm for what is being created. God finds the whole of creation to be not only good but delightful, “the occasion for intense and sustained joy.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-015",
      "id": "ap_ntf-015-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To top it off, God digs a garden, “"), _c('i', [_vm._v("a place of utter delight ")]), _vm._v("” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Genesis+2%3A8&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Genesis 2:8")]), _vm._v(") and creates humans as its caretakers. God not only delights in creation but loves to share that world with us and rejoices over our appreciation of its beauty and our acceptance of our role as its stewards. My vivid imagination has God walking through the garden with Adam and Eve pointing out plants, insects, and furry creatures to them saying, “Did you notice this one, see how perfectly it fulfills its part in my plan? I had such fun creating it.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Can you imagine the grief God must have felt at our disobedience? We no longer delighted in our Creator but hid in fear instead. We no longer saw God as delighting in us but viewed the Eternal One as an authoritarian, judgmental, punishing God we could never please. We no longer found joy in the stewardship of this beautiful creation either but saw our labors as toil and struggle, and ourselves as conquerors rather than preservers.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Fortunately, the gospel story offers us hope. In "), _c('i', [_vm._v("A New Heaven and a New Earth")]), _vm._v(" Richard Middleton says,")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Many recent studies of the garden of Eden in Genesis suggest that this garden, in its relationship to the rest of the earth, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("functions as an analogue of the holy of holies in the tabernacle or the Jerusalem temple. The garden is the initial core location of God’s presence on earth; this is where God’s presence is first manifest, both in giving instructions to humanity (2:15-17) and in declaring judgement (3:8-19). The garden is thus the link between earth and heaven, at least at the beginning of human history. The implication is that as the human race faithfully tended this garden or cultivated the earth, the garden would spread, until the entire earthly realm was transformed into a fit habitation for humanity. But it would thereby also become a fit habitation for God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-016",
      "id": "ap_ntf-016-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _c('div', {
    staticClass: "encsansfilet",
    attrs: {
      "id": "enc-004"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('figure', {
    staticClass: "fighaut",
    attrs: {
      "id": "carre1"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/carre.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("What if the goal of our spiritual disciplines was to restore the intense joy and enthusiasm God experienced on the seventh day of creation?")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("What if the goal of our spiritual disciplines was to restore the intense joy and enthusiasm God experienced on the seventh day of creation? Imagine what our lives would look like if our deepest delight was to transform ourselves, our neighbors, and the earth until all becomes once again not just a fitting habitation for humanity but also for God.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("According to Heschel, “The essence of the world to come is Sabbath eternal.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-017",
      "id": "ap_ntf-017-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Sabbath is not a rest of exhaustion but of delight. When the Jews looked forward to the Sabbath, they looked beyond the pain of a broken world to the glimpses of wholeness in the past week. The greeting that ushered in the Sabbath day, “"), _c('i', [_vm._v("Shabbat Shalom")]), _vm._v(",” basically meant, “May you live in anticipation of the day when God makes all things whole again.” This was the culmination of their week, a preview of the world in which Sabbath eternal would reemerge and all God’s creation would live in harmony, peace, and abundance.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("Jesus and his announcing of God’s new creation fulfills this dream. As I comment in my previous book "), _c('i', [_vm._v("Godspace: Time for Peace in the Rhythms of Life")]), _vm._v(":")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("No wonder he healed on the Sabbath and constantly criticized the legalisms and restrictive rules the Pharisees inflicted on the people, robbing them of their joy and freedom. He wasn’t downplaying the importance of Sabbath as a holy day, he was showing the Jews what Sabbath was meant to be—a glimpse into the wholeness and abundance of a "), _c('i', [_vm._v("shalom")]), _vm._v(" future when all will be healed, fed and provided for."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen6#ntf-018",
      "id": "ap_ntf-018-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When I look at Jesus, I see a man with childlike enthusiasm. He loved life, relished the beauty of God’s creation, played with children, and enjoyed friendships enthusiastically. I see him rejoicing as he feeds and heals people and breaks down barriers of power and injustice. As I watch him walk through Palestine with his friends, it is not just a love of freedom, justice, and generosity that I sense God loves. More playful images come to mind. "), _c('i', [_vm._v("God loves to have fun and surprise people")]), _vm._v(", I conclude as Jesus turns water into wine at a wedding. "), _c('i', [_vm._v("God enjoys a good meal")]), _vm._v(", I surmise as I watch Jesus eat with his friends. "), _c('i', [_vm._v("God loves to celebrate and party")]), _vm._v(", I imagine as I see Jesus going up to Jerusalem for the Jewish feasts.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What difference would it make to our spiritual practices if we approached life with childlike enthusiasm and made modeling glimpses of God’s shalom world our goal? How would we reorder our lives if we started each day by asking, "), _c('i', [_vm._v("What does God enjoy about me, and what could I do today to bring joy to God? ")]), _vm._v("How would we reshape our spiritual practices if we saw them as tools to draw us closer to God, to each other, and to God’s beautiful world? I suspect this would cast a different view of the day ahead and for the purpose of what we do.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d79414a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1.vue
// module id = 69
// module chunks = 0